import {AxiosResponse} from "axios";
import React from "react";
import {RouteComponentProps, withRouter} from "react-router-dom";
import {HttpError} from "../../../../common/components/shared/httpError/httpError";
import Loader from "../../../../common/components/shared/loader/loader";
import {HttpErrorModel} from "../../../../common/models/httpError";
import {RouteParamsModel} from "../../../../common/models/routeParams";
import {Api} from "../../../../helpers/api";
import i18n from "../../../../i18n/i18n";
import {storesContext} from "../../../../common/stores/stores";
import {observer} from "mobx-react";
import {TicketDetailModel} from "../../../models/ticket";
import {TicketService} from "../../../services/ticketService";
import {ITicketStore} from "../../../stores/ticketStore";
import TicketForm from "../ticketForm/ticketForm";

interface ModifyTicketState {
    ticketData?: TicketDetailModel | null;
    response: AxiosResponse<HttpErrorModel[] | any> | undefined;
}

class ModifyTicket extends React.Component <RouteComponentProps, ModifyTicketState> {
    static contextType = storesContext;

    constructor(props: any) {
        super(props);

        this.state = {
            ticketData: null,
            response: undefined
        };
    }

    private get ticketData() {
        return this.state.ticketData;
    }

    async componentDidMount() {
        const params = this.props.match.params as RouteParamsModel;
        const response = await TicketService.getTicket(params.id);

        this.setState({response});

        if (Api.isSuccess(response)) {
            this.setState({
                ticketData: response?.data || null
            });

            this.setTicketStore();
        }
    }

    render() {
        return (
            <div className="modify-ticket modify-record">
                <div className="content">
                    <div className="header">
                        {i18n.t("transportation.ticket.modifyTicket.header")}
                    </div>
                    {this.renderContent()}
                </div>
            </div>
        );
    }

    private renderContent() {
        const params = this.props.match.params as RouteParamsModel;

        if (!Api.isSuccess(this.state.response)) {
            return <HttpError
                response={this.state.response}
                cause={i18n.t("transportation.ticket.modifyTicket.errors.retrievalErrorSuffix")}
            />;
        } else if (this.ticketData) {
            return <TicketForm isUpdate={true} id={params.id}/>;
        } else {
            return (
                <Loader/>
            );
        }
    }

    private setTicketStore() {
        const ticketStore = this.context.ticketStore as ITicketStore;

        ticketStore.setTicket(this.ticketData);
    }
}

export default withRouter(observer(ModifyTicket));